var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0.666992C8.87999 0.666992 0.666656 8.88033 0.666656 19.0003C0.666656 29.1203 8.87999 37.3337 19 37.3337C29.12 37.3337 37.3333 29.1203 37.3333 19.0003C37.3333 8.88033 29.12 0.666992 19 0.666992ZM19 6.16699C22.0433 6.16699 24.5 8.62366 24.5 11.667C24.5 14.7103 22.0433 17.167 19 17.167C15.9567 17.167 13.5 14.7103 13.5 11.667C13.5 8.62366 15.9567 6.16699 19 6.16699ZM19 32.2003C14.4167 32.2003 10.365 29.8537 7.99999 26.297C8.05499 22.6487 15.3333 20.6503 19 20.6503C22.6483 20.6503 29.945 22.6487 30 26.297C27.635 29.8537 23.5833 32.2003 19 32.2003Z",
    fill: "#012A36"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.bf0f288ed8bc00510a5677e20e0bba22.svg";
export { ForwardRef as ReactComponent };